module.exports = __webpack_public_path__ + "static/media/seguridad.68fbdf40.jpg";